import { IEnvironment } from './IEnvironment';

export const environment: IEnvironment = {
  production: true,
  demo: false,
  title: 'ECLSWeb 2.0',
  name: '',
  scApiPort: '443',
  scApiHost: 'EclsWeb20Services.empirecls.com',
  scApiProtocol: 'https',
  weatherApiKey: 'dd3f92f827b4ccb998fe44cbcd9e6a06',

  deploymentType: 'customer'
};
